import React, { useState } from "react";
import { formatNumber } from "../../functions/formatNumber";

import Tooltip from "@mui/material/Tooltip";
import { Button } from "@mui/material";
import InfoIcon from "./InfoIcon";

// scontrino row item -----------------------------------
const LabelValueRow = ({
  label,
  meta,
  value,
  important,
  type,
  tooltipText,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="flex flex-row justify-between items-center py-1 text-md ">
      <div className="flex flex-row items-center gap-x-1">
        <span
          className={`${
            important ? "text-black dark:text-white font-bold" : "text-gray-400"
          }`}
        >
          {label}
        </span>
        {meta !== null && <span className="text-orange-400"> {meta}</span>}
        {tooltipText !== undefined && (
          <Tooltip
            title={tooltipText}
            arrow
            style={{ position: "relative", zIndex: "0" }}
            open={showTooltip}
            onOpen={() => setShowTooltip(true)}
            onClose={() => setShowTooltip(false)}
          >
            <Button
              variant="outlined"
              style={{ border: "none", overflow: "visible" }}
              onClick={() => setShowTooltip(!showTooltip)}
            >
              <InfoIcon className="dark:fill-[white]" />
            </Button>
          </Tooltip>
        )}
      </div>

      <span
        className={`${
          important ? "text-black dark:text-white font-bold" : "text-gray-400"
        } whitespace-nowrap`}
      >
        {`${formatNumber(value) + (type !== "perc" ? ` €` : ` %`)}`}
      </span>
    </div>
  );
};

export default LabelValueRow;
